import { FieldType, ViewModelBase } from "@shoothill/core";
import { action, computed, observable, reaction, runInAction } from "mobx";

// View models
import FormSectionViewModelBase from "Globals/ViewModels/FormSections/FormSectionViewModelBase";

// Models
import { CreditReportModel } from "Globals/Models/Domain/FormSections/CreditReport/CreditReportModel";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { CreditReportDTO } from "Globals/Models/DTO/CreditReportDTO";
import { UserFile } from "Globals/Models/UserFile";
import { ParentCreditReportModel } from "Globals/Models/Domain/FormSections/CreditReport/ParentCreditReportModel";
import CreditReportViewModel from "./CreditReportViewModel";

export default class ParentCreditReportViewModel extends FormSectionViewModelBase<ParentCreditReportModel> {
    @observable public creditReportViewModels: CreditReportViewModel[] = [];

    constructor(creditReportModel: ParentCreditReportModel, _updateSectionCompleted: (index: FormSectionsEnum, value: boolean) => void) {
        super(_updateSectionCompleted, creditReportModel);
        this.createViewModels();
        if (this.updateSectionCompleted) {
            this.updateSectionCompleted(FormSectionsEnum.CreditReport, this.canProceed);
        }
    }

    @action
    private createViewModels(): void {
        if (this.model.creditReportModels) {
            for (const model of this.model.creditReportModels) {
                this.creditReportViewModels.push(new CreditReportViewModel(model));
            }
        }
    }

    @computed
    public get getSorted(): CreditReportViewModel[] {
        return this.creditReportViewModels
            .slice()
            .sort((a, b) => (b.model.createdDate ? new Date(b.model.createdDate).getTime() : 0) - (a.model.createdDate ? new Date(a.model.createdDate).getTime() : 0));
    }
    @computed
    public get getUserFiles(): UserFile[] {
        let userFiles: UserFile[] = [];
        this.getSorted.forEach((a) => {
            userFiles.push({
                id: a.model.id,
                documentTypeId: "",
                fileName: a.model.creditFileName,
                fileUrl: a.model.creditDocumentUrl,
            });
        });
        return userFiles;
    }

    @action
    public handleInputChange = (): void => {
        this.updateSectionCompleted(FormSectionsEnum.CreditReport, this.canProceed);
    };

    @computed
    public get canProceed(): boolean {
        let completed = true;
        if (this.creditReportViewModels.length < 1) {
            completed = false;
        }
        return completed;
    }

    public async isFieldValid(fieldName: keyof FieldType<ParentCreditReportModel>, value: any): Promise<boolean> {
        return await this.isValid(fieldName, value);
    }

    public async isValid(fieldName: keyof FieldType<ParentCreditReportModel>, value: any, isRequired: boolean = false): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        if (fieldName == "reportsRequired") {
            if (value === true) {
                if (this.creditReportViewModels.length < 1) {
                    errorMessage = "required to proceed";
                    isValid = false;
                }
            }
        }
        if (isValid == false) {
            console.log("Field Not valid: ", fieldName);
        }
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }

    /**
     * @returns boolean does this section have any errors
     */
    @action
    public async showUnfinishedFields(): Promise<boolean> {
        let hasError = false;
        for (const _field of Object.keys(this.model)) {
            let field = _field as keyof FieldType<ParentCreditReportModel>;
            let value = this.model.getValue(field);
            let isRequired = true;
            let isValid = await this.isValid(field, value, isRequired);
            if (isValid == false) {
                hasError = true;
            }
        }
        return hasError;
    }
    public beforeUpdate: undefined;
}
